import { useTaskTrackerStore, selectTaskByScope } from '@/modules/shared/stores/taskTrackerStore'

export type ScopeBusy = {
  /** True while any task occupies this work scope. */
  busy: boolean
  /** True when the occupying task belongs to somebody else. */
  byOther: boolean
  /** Login of whoever started it, when the server told us. */
  startedBy: string | null
  taskId: string | null
}

const IDLE: ScopeBusy = {
  busy: false,
  byOther: false,
  startedBy: null,
  taskId: null,
}

/**
 * Whether a given work scope is already being processed — including by another user
 * of the same company, which is the case this whole mechanism exists for.
 *
 * Use it to disable the button and explain why. It is UX, not a safeguard: two
 * browsers can both read "free" at the same instant. The actual guarantee is the
 * server's unique index on ScopeKey, which turns the loser of that race into a 409
 * that `startTrackedTask` adopts.
 */
export const useScopeBusy = (scopeKey: string | null | undefined): ScopeBusy => {
  const task = useTaskTrackerStore(selectTaskByScope(scopeKey))
  if (!task) return IDLE
  return {
    busy: true,
    byOther: !task.mine,
    startedBy: task.createdByLogin,
    taskId: task.id,
  }
}
